import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import MultiSelect from '../MultiSelect';

function MultiSelectWithOption({
  maxTagTextLength,
  maxTagCount,
  maxTagPlaceholder,
  placeholder,
  onChangeAllSelected,
  values,
  onChange,
  loading,
  disabled,
  height,
  onClose,
  options,
  labelKey,
  valueKey,
}) {
  const getLabel = (option) => {
    if (!labelKey) return option;
    return option[labelKey];
  };

  const getValue = (option) => {
    if (!valueKey) return option;
    return option[valueKey];
  };

  const onChangeAllSelectedDefault = () => {
    if (values && values.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map((option) => getValue(option)));
    }
  };

  return (
    <MultiSelect
      maxTagTextLength={maxTagTextLength}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      placeholder={placeholder}
      style={{ width: '100%' }}
      areAllSelected={values ? values.length === options.length : false}
      onChangeAllSelected={onChangeAllSelected || onChangeAllSelectedDefault}
      value={values || []}
      onChange={onChange}
      loading={loading}
      disabled={disabled}
      height={height}
      onClose={onClose}
    >
      {options.map((option, index) => (
        <Select.Option
          // eslint-disable-next-line react/no-array-index-key
          key={`option-${index}`}
          value={getValue(option)}
        >
          {getLabel(option)}
        </Select.Option>
      ))}
    </MultiSelect>
  );
}

MultiSelectWithOption.propTypes = {
  maxTagTextLength: PropTypes.number,
  maxTagCount: PropTypes.number,
  maxTagPlaceholder: PropTypes.func,
  placeholder: PropTypes.node,
  onChangeAllSelected: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  height: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any,
  onClose: PropTypes.func,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
};

MultiSelectWithOption.defaultProps = {
  maxTagTextLength: 10,
  maxTagCount: 2,
  maxTagPlaceholder: (selectedValues) => `+${selectedValues.length} selecionados`,
  placeholder: undefined,
  loading: false,
  disabled: false,
  height: '32px',
  values: undefined,
  options: [],
  onClose: undefined,
  labelKey: '',
  valueKey: '',
};

export default MultiSelectWithOption;
